import 'es6-promise';
import 'isomorphic-fetch';
import config from '../../config';
import { createAction } from 'redux-actions';
import { getUrlParam } from '../../helper/dish-helper';
import { getRunEnv } from '../../helper/common-helper';
import fetchHelper from '../../helper/fetch-helper';
import ccbAppHelper from '../../helper/Ccb-app-helper';
import pageHelper from '../../helper/page-helper';

const setMenuList = createAction('SET_MENU_LIST', menuList => menuList);
const setUserInfo = createAction('SET_USER_INFO', userInfo => userInfo);
export const setToastProps = createAction('SET_TOAST_PROPS', props => props);
const setShopDetail = createAction('SET_SHOP_DETAIL', shopDetail => shopDetail);
export const setErrorMsg = createAction('SET_ERROR_MSG', error => error);
const setShopIntroImgs = createAction('SET_SHOP_INTRO_IMGS', shopIntroImgs => shopIntroImgs);
const setServiceCardVO = createAction('SET_SERVICE_CARDVO', serviceCardVO => serviceCardVO);
export const setSocketCardData = createAction('SET_SOCKET_CARD_DATA', socketcarddata => socketcarddata);
const setShopInfo = createAction('SET_SHOP_INFO', shopInfo => shopInfo);
export const setLoading = createAction('SET_LOADING', msg => msg);

const shopId = getUrlParam('shopId');
const tableId = getUrlParam('tableId');
const runEnv = getRunEnv();
const shopInfoUrl = `${config.orderallShopInfoAPI}?shopId=${shopId}&runEnv=${runEnv}`;

export const fetchShopDetail = () => dispatch => {
  let detailUrl = `${config.shopDetailURL}.json?shopId=${shopId}`;

  if (tableId) {
    detailUrl = `${config.shopDetailURL}.json?shopId=${shopId}&tableId=${tableId}`;
  }
  return fetchHelper
    .get(detailUrl)
    .then(result => {
      if (result) {
        const { shop = {}, detailLogoList, menuList = [] } = result || {};
        let newMenuList = menuList;
        // 建行环境只显示堂食
        if (ccbAppHelper.isCcbEvn()) {
          newMenuList = menuList.filter((item = {}) => item.uniqueId === 'TS');
        }
        // 处理门店menu链接
        newMenuList.forEach((item) => {
          switch (item.uniqueId) {
            case 'TS':
              item.link = `${config.dishMenu4DinnerURL}?shopId=${shop.commercialID}&type=TS&fromTsButton=true`;
              break;
            case 'WM':
              item.link = `${config.dishMenu4takeoutURL}?shopId=${shop.commercialID}&type=WM`;
              break;
            case 'XLS':
              item.link = `${config.dishMenu4takeoutURL}?shopId=${shop.commercialID}&type=WM`;
              break;
            case 'YD':
              item.link = `${config.bookingURL}?shopId=${shop.commercialID}`;
              break;
            case 'HY':
              item.link = `${config.memberIndexURL}?shopId=${shop.commercialID}&fromShopHome=1`;
              break;
            case 'WD':
              item.link = `${config.mineIndexURL}?shopId=${shop.commercialID}&fromShopHome=1`;
              break;
            default:
          }
        });

        dispatch(setShopDetail(shop));
        dispatch(setShopIntroImgs(detailLogoList));
        dispatch(setMenuList(newMenuList));
      }
    })
    .catch(err => {
      console.log('获取外送基本信息失败...');
    });
};

export const getCheckQueue = () => (dispatch, getState) => {
  const commercialID = getState().shopDetail.commercialID;
  fetchHelper
    .get(`${config.checkQueueAPI}?shopId=${commercialID}`, null, { enableDefaultResponseResolve: false })
    .then((res = {}) => {
      const { data: resData = {} } = res;
      const { data, code, msg } = resData;
      switch (code) {
        case '200': {
          if (data.queueTip) {
            location.href = `${config.queueDetailURL}?shopId=${commercialID}&orderSyn=${data.orderSyn}`;
          } else {
            location.href = `${config.queueInfoURL}?shopId=${commercialID}`;
          }
          break;
        }
        case 'NOT_LOGIN': {
          // location.href = `${config.queueInfoURL}?shopId=${commercialID}`;
          // 排队之前需要先登录
          const url = `${config.queueInfoURL}?shopId=${commercialID}`;
          pageHelper.navigateToLoginPage({
            shopId: commercialID,
            returnUrl: encodeURIComponent(url),
          });
          break;
        }
        default: {
          dispatch(setErrorMsg({ text: msg }));
          break;
        }
      }
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg({ text: err.msg }));
    });
};

export const fetchUserInfo = () => (dispatch, getState) => {
  fetchHelper
    .get(`${config.individualAPI}?shopId=${shopId}`, null, { enableDefaultResponseResolve: false })
    .then((res = {}) => {
      const { data: resData = {} } = res;
      const { data, code } = resData;
      switch (code) {
        case '200': {
          dispatch(setUserInfo(data));
          break;
        }
        case 'NOT_LOGIN': {
          dispatch(setUserInfo());
          break;
        }
        default: {
          break;
        }
      }
    })
    .catch((err = {}) => {
      console.warn(err);
    });
};

export const fetchServiceCard = () => (dispatch, getState) => {
  const tableParam = tableId ? `&tableId=${tableId}` : '';
  fetchHelper
    .get(`${config.serviceCardAPI}?shopId=${shopId}${tableParam}`)
    .then(res => {
      if (res) {
        dispatch(setServiceCardVO(res));
      }
    })
    .catch((err = {}) => {
      const { msg = '' } = err;
      dispatch(setErrorMsg({ text: msg }));
      sessionStorage.errorMsg = msg;
      setTimeout(() => {
        location.href = `${config.exceptionLinkURL}?shopId=${shopId}&linkType=1&diningForm=0`;
      }, 1500);
    });
};

export const clearErrorMsg = () => (dispatch, getStates) => {
  dispatch(setErrorMsg({}));
};

export const fetchShopInfo = () => dispatch =>
  fetchHelper
    .get(shopInfoUrl)
    .then(res => dispatch(setShopInfo(res)))
    .catch((err = {}) => dispatch(setErrorMsg({ text: err.msg })));



// WEBPACK FOOTER //
// ./src/action/shop-home/shop-home.js